<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>CT、MRI教学机（桌面孪生版）</h1>
      </div>

      <div class="ct-content">
        <!-- 文字在上，图片垂直在下 单栏布局 -->
        <div class="single-col-card">
          <section class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
            <p class="text-content">{{ p[1] }}</p>
          </section>
          <!-- 设备图片行【优化布局】 -->
          <el-row :gutter="24" class="img-row">
  <el-col :xs="12" :sm="12" :md="12" :lg="12" v-for="(item,index) in img" :key="index">
    <div class="main-banner imgLimit">
      <img loading="lazy" :src="item" alt="CT MRI桌面孪生教学机 无辐射仿真实训设备实拍图" class="banner-img" />
      <div class="banner-glow"></div>
    </div>
  </el-col>
</el-row>
          <!-- 分类模块卡片组件 -->
          <CardBorder :h6="h6" :msg="listP" :img="0"></CardBorder>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardBorder from "./cardBorder.vue"
import { fenHaoArray,kuoHaoArray } from '@/js/pdArray.js'
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false
    }
  },
  name: "HardCTTwin",
  components:{
    CardBorder,
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      p:[
        "2025年教育部新版《医学影像技术专业教学标准》与《教育领域重大设备更新实施方案》落地，要求强化实践教学、推进虚实融合实训。当前院校面临大型CT、MRI设备造价高昂、资源紧缺难题，学生实操机会不足，“看得多、练得少”，难以满足全员常态化实操教学要求。",
        "医影智能CT/MRI孪生版桌面教学机严格按照临床真机1:2.5微缩复刻，完整保留真机全部核心功能，支持床体移动、定位校准、软件联动等全套操作。轻量化桌面设计，无需专用机房、无辐射，支持院校批量采购，一间教室部署多台设备，实现学生同步实操。配套智能教学管控系统，教师Pad远程管控，实训数据云端留存可追溯。设备助力院校搭建轻量化、标准化影像实训中心，适配新时代医学影像人才培养需求。"
      ],
      img:[
        require('@/assets/image/d1.png'),
        require('@/assets/image/d2.png'),
        require('@/assets/image/d7.png'),
        require('@/assets/image/8.png'),
        
      ],
      h6:[
        "等比例仿真机身",
        "扫描床驱动系统",
        "仿真控制面板",
        "设备联动主控系统",
        "配套实训操作软件",
        "远程教学管控平台",
        "云端教学数据管理"
      ],
      listP:[],
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  },
  created(){
    let a = new Array(7)
    a[0] = `严格遵循临床真机1:2.5比例微缩，完整复刻机架、外壳、组件布局，桌面轻量化摆放，无辐射，安全实训。`
    a[1] = `仿真电动扫描床，支持进退、定位复位，匹配真机运动逻辑，还原临床操作手感。`
    a[2] = `复刻实体操作面板，按键布局与真机保持一致，配套实训软件联动控制。`
    a[3] = `整机硬件信号联动，床体、定位灯、控制系统同步协同，模拟真实设备运行逻辑。`
    a[4] = `配套CT/MRI仿真扫描软件，支持扫描定位、参数设置、图像浏览、窗宽窗位调节。`
    a[5] = `教师移动端Pad远程管控，设备锁定、统一下发实训任务，课堂灵活教学。`
    a[6] = `实训操作数据云端自动存储，实训时长、操作记录自动统计，实现教学过程可追溯。`

    a[0] = kuoHaoArray(a[0])
    a[1] = kuoHaoArray(a[1])
    a[2] = kuoHaoArray(a[2])
    a[3] = kuoHaoArray(a[3])
    a[4] = kuoHaoArray(a[4])
    a[5] = kuoHaoArray(a[5])
    a[6] = kuoHaoArray(a[6])
    this.listP = a
  }
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1{
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（与CT/DR/MRI完全一致）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // ==========【优化图片区域样式】==========
  .img-row {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }

  .imgLimit.main-banner {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    width: 100%;
    // aspect-ratio: 16 / 11;
    background: #f7f9fc;
    margin-bottom: 30px;
  }
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center -15%;
    display: block;
    // transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }
}

// 暗色模式完整适配（与CT/DR/MRI页面逻辑完全同步）
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>